import { FormattedMessage } from 'react-intl';

import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { RadioGroup } from '@sorare/core/src/atoms/inputs/RadioGroup';

import { SelectHeader } from 'atoms/SelectHeader';
import {
  AVAILABLE_TIMEFRAMES,
  type Timeframe,
  timeframeMessages,
} from 'lib/timeframe';

const options = AVAILABLE_TIMEFRAMES.map(tf => ({
  label: <FormattedMessage {...timeframeMessages[tf]} />,
  value: tf,
}));

type Props = {
  value: Timeframe;
  onChange: (t: Timeframe) => void;
  buttonSize?: 'small' | 'medium' | 'compact' | undefined;
};

export const TimeframeSelector = ({
  value,
  onChange,
  buttonSize = 'small',
}: Props) => {
  const selectedOption = options.find(tf => tf.value === value) || options[2];
  return (
    <FilterInDropdown
      buttonLabel={selectedOption.label}
      buttonSize={buttonSize}
    >
      {({ closeDropdown }) => (
        <>
          <SelectHeader>
            <FormattedMessage
              id="TimeFrameSelector.title"
              defaultMessage="Select time period"
            />
          </SelectHeader>
          <RadioGroup
            modalSelect
            options={options}
            value={selectedOption.value}
            name="time-frame-selector-chart"
            onChange={tf => {
              onChange(tf);
              closeDropdown();
            }}
          />
        </>
      )}
    </FilterInDropdown>
  );
};
